var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}},[_c('path',{attrs:{"d":"M7.5,11.9v2.2h11V11.9ZM13,2A11,11,0,1,0,24,13,11,11,0,0,0,13,2Zm0,19.8A8.8,8.8,0,1,1,21.8,13,8.812,8.812,0,0,1,13,21.8Z","transform":"translate(-2 -2)","fill":"#a4a4a4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }